import React from 'react';

interface ReadingModeToggleProps {
  personaName: string;
  readingMode: 'brief' | 'full';
  onModeChange: (mode: 'brief' | 'full') => void;
}

const ReadingModeToggle: React.FC<ReadingModeToggleProps> = ({
  personaName,
  readingMode,
  onModeChange
}) => {
  return (
    <div className="max-w-[812px] mx-auto px-4 md:px-0 mb-5">
      <div className="flex items-center justify-between">
        <span
          className="text-[11px] font-bold text-[#94a3b8] tracking-wider"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            textTransform: 'uppercase',
            letterSpacing: '0.06em'
          }}
        >
          {personaName}&apos;s analysis
        </span>
        <div className="flex rounded-lg p-[3px]" style={{ background: '#f5f5f4' }}>
          <button
            onClick={() => onModeChange('brief')}
            className="px-3 py-1.5 rounded-md text-[12px] font-bold transition-all"
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              background: readingMode === 'brief' ? 'white' : 'transparent',
              color: readingMode === 'brief' ? '#0f172a' : '#94a3b8',
              boxShadow: readingMode === 'brief' ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'
            }}
          >
            Argument Brief
          </button>
          <button
            onClick={() => onModeChange('full')}
            className="px-3 py-1.5 rounded-md text-[12px] font-bold transition-all"
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              background: readingMode === 'full' ? 'white' : 'transparent',
              color: readingMode === 'full' ? '#0f172a' : '#94a3b8',
              boxShadow: readingMode === 'full' ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'
            }}
          >
            Full Analysis
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReadingModeToggle;
